import type { Product } from './ProductCard';

interface PackagingOptionsProps {
  product: Product;
}

const packagingIcons: Record<string, string> = {
  'Resealable Pouch': 'ri-archive-line',
  'Stand-up Bag': 'ri-shopping-bag-line',
  'Bulk Sack': 'ri-box-3-line',
  'Vacuum Sealed Bag': 'ri-shield-check-line',
  'Kraft Paper Bag': 'ri-leaf-line',
};

export default function PackagingOptions({ product }: PackagingOptionsProps) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-100">
        <h3 className="text-gray-900 font-bold text-lg">Packaging Options</h3>
        <p className="text-sm text-gray-500 mt-1">All packaging is food-grade, moisture-proof, and UV-resistant</p>
      </div>
      <div className="divide-y divide-gray-100">
        {product.packaging.map((pkg, i) => (
          <div key={i} className="flex items-center gap-5 px-6 py-4 hover:bg-amber-50/40 transition-colors">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-amber-100 text-amber-700 flex-shrink-0">
              <i className={`${packagingIcons[pkg.type] || 'ri-archive-line'} text-xl`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm font-bold text-gray-900">{pkg.size}</span>
                <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">{pkg.type}</span>
              </div>
              <p className="text-xs text-gray-500 mt-0.5">Shelf Life: <strong className="text-gray-700">{pkg.shelfLife}</strong></p>
            </div>
            <div className="text-right flex-shrink-0">
              <span className="text-sm font-bold text-amber-700">{pkg.price}</span>
              <p className="text-xs text-gray-400">per unit</p>
            </div>
          </div>
        ))}
      </div>
      <div className="px-6 py-4 bg-amber-50 border-t border-amber-100">
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-amber-600 text-base"></i>
          </div>
          <p className="text-xs text-amber-800 leading-relaxed">
            Custom packaging and private label options available for orders of 10kg and above. Contact us for branding inquiries.
          </p>
        </div>
      </div>
    </div>
  );
}
